module.exports = __webpack_public_path__ + "static/media/Email_Icon.ae6833bf.svg";